import Icon from './icon.svg?react'
import * as Styles from './styles'

const ParcelPackedIcon = ({ size, color }) => {
  return (
    <Styles.Container color={color}>
      <Icon height={size} width={size} />
    </Styles.Container>
  )
}

export default ParcelPackedIcon
